import axios from "axios";
import * as paths from "../constants/paths";

const instance = axios.create({
  baseURL: paths.API_OPENSEARCH_URL,
  headers: {
    "Content-type": "application/json",
  },
});

// Attach the current authToken on every request rather than caching it at
// module-load time. The previous "const token = localStorage.getItem(...)
// at module scope" pattern baked whatever value was present when this file
// first ran into the axios instance forever — so a login (or auto-login
// like the enterprise-user-checkout flow) updated localStorage but the
// in-flight axios default header still carried the old/empty token.
//
// Callers can override on a per-request basis by setting headers.Authorization
// explicitly (including to ""). The `undefined` check below preserves that
// override rather than clobbering it from localStorage.
instance.interceptors.request.use((config) => {
  if (config.headers?.Authorization === undefined) {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token;
    }
  }
  return config;
});

export default instance;
